/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEnterpriseSystemSettings200ResponseSettings } from './GetEnterpriseSystemSettings200ResponseSettings';
import {
    GetEnterpriseSystemSettings200ResponseSettingsFromJSON,
    GetEnterpriseSystemSettings200ResponseSettingsFromJSONTyped,
    GetEnterpriseSystemSettings200ResponseSettingsToJSON,
} from './GetEnterpriseSystemSettings200ResponseSettings';

/**
 * 
 * @export
 * @interface GetEnterpriseSystemSettings200Response
 */
export interface GetEnterpriseSystemSettings200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetEnterpriseSystemSettings200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetEnterpriseSystemSettings200Response
     */
    message: string;
    /**
     * 
     * @type {GetEnterpriseSystemSettings200ResponseSettings}
     * @memberof GetEnterpriseSystemSettings200Response
     */
    settings: GetEnterpriseSystemSettings200ResponseSettings;
}

/**
 * Check if a given object implements the GetEnterpriseSystemSettings200Response interface.
 */
export function instanceOfGetEnterpriseSystemSettings200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "settings" in value;

    return isInstance;
}

export function GetEnterpriseSystemSettings200ResponseFromJSON(json: any): GetEnterpriseSystemSettings200Response {
    return GetEnterpriseSystemSettings200ResponseFromJSONTyped(json, false);
}

export function GetEnterpriseSystemSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEnterpriseSystemSettings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'settings': GetEnterpriseSystemSettings200ResponseSettingsFromJSON(json['settings']),
    };
}

export function GetEnterpriseSystemSettings200ResponseToJSON(value?: GetEnterpriseSystemSettings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'settings': GetEnterpriseSystemSettings200ResponseSettingsToJSON(value.settings),
    };
}

